require('./index.css');



// WEBPACK FOOTER //
// ../node_modules/@tencent/pcqb-act-footer/src/index.js